<template>
  <div class="line">
    <div class="con">
      <div class="bau">
        <img src="../../../assets/img/SSGJ/baud.png" alt />
      </div>
      <div class="libox">
        <div class="li" v-for="(item,index) in List" :key="index">
          <div class="wz">
            <p>{{item.name}}</p>
            <p v-if="index % 2 != 1">
              <span></span>
              <span>{{item.value}}</span>
            </p>
            <p v-else>
              <span></span>
              <span>{{item.value}}</span>
            </p>
          </div>
          <div class="btn">
            <p
              v-for="(val,ind) in item.btn"
              :key="ind"
              :class="(index).toString()+ind==SBDKPXindex?'ac':''"
              @click="SBDKPXPoint(ind,index)"
            >{{val}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    List: {
      type: Array,
      default: () => {
        return [
          {
            name: 'Server-b22',
            value: 'SQL-1',
            btn: ['设 备', '端 口']
          },
          {
            name: 'SQL数据库服务_port_SQL-1_D04_ODF1_port_OP-2',
            value: 'OP-2',
            btn: ['配 线']
          },
          {
            name: 'Server-b23',
            value: 'OP-3',
            btn: ['设 备', '端 口']
          }
        ]
      }
    }
  },
  data() {
    return {
      SBDKPXindex: -1
    }
  },
  methods: {
    SBDKPXPoint(i, maxIndex) {
      if (this.SBDKPXindex == maxIndex.toString() + i) {
        this.SBDKPXindex = -1
        this.$emit('changeSBDKPXPoint', '')
      } else {
        this.SBDKPXindex = maxIndex.toString() + i
        this.$emit('changeSBDKPXPoint', this.title)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.line {
  margin-left: -50px;
  width: 676px;
  height: 1004px;
  background: rgba(24, 155, 250, 0.1);
  .con {
    display: flex;
    width: 576px;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    .bau {
      margin-top: 58px;
    }
    .libox {
      height: 402px;
      // overflow-y: auto;
      overflow-x: hidden;
    }
    ::-webkit-scrollbar {
      width: 0px;
      border-radius: 0px;
      background: rgba(17, 63, 89, 0.65);
    }
    ::-webkit-scrollbar-thumb {
      width: 0px;
      border-radius: 0px;
      background: rgba(255, 255, 255, 0.15);
      min-height: 00px;
    }
    .btn {
      width: 110px;
      p {
        pointer-events: all;
        margin-bottom: 12px;
        width: 110px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: url('../../../assets/img/SSGJ/btn.png') no-repeat;
        font-size: 26px;
        font-family: '微软雅黑';
        color: #ccc;
      }
      .ac {
        margin-bottom: 12px;
        width: 110px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: url('../../../assets/img/SSGJ/btnac.png') no-repeat;
        font-size: 26px;
        font-family: '微软雅黑';
        color: #ccc;
      }
    }
    .li {
      margin-bottom: 16px;
      width: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      .wz {
        width: 390px;
        p:nth-child(1) {
          font-size: 26px;
          font-family: '微软雅黑';
          color: #fff;
        }
        p:nth-child(2) {
          display: flex;
          align-items: center;
          span:nth-child(1) {
            width: 10px;
            height: 10px;
            background: #55b7ff;
            border-radius: 50%;
            margin-right: 10px;
          }
          span:nth-child(2) {
            font-size: 26px;
            font-family: '微软雅黑';
            color: #fff;
          }
        }
      }
    }
    .li:nth-child(odd) {
      height: 136px;
    }
    .li:nth-child(even) {
      height: 110px;
      width: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      .wz {
        width: 390px;
        p:nth-child(1) {
          font-size: 26px;
          font-family: '微软雅黑';
          color: #52f2ff;
        }
        p:nth-child(2) {
          display: none;
          align-items: center;
          span:nth-child(1) {
            width: 10px;
            height: 10px;
            background: #55b7ff;
            border-radius: 50%;
          }
          span:nth-child(2) {
            font-size: 26px;
            font-family: '微软雅黑';
            color: #fff;
          }
        }
      }
    }
  }
}
</style>